import { gsap } from 'gsap'

export const slideWithOpacity = (arr, stagger, delay) => {
	gsap.to(arr, {
		y: 0,
		opacity: 1,
		stagger: stagger || 0.2,
		delay: delay,
	})
}

export const changeWidth = (text) => {
	gsap.to(text, 0.5, {
		width: '100%',
	})
}

export const scaleAnimation = (item, delay) => {
	gsap.to(item, {
		scale: 1,
		delay: delay,
	})
}

export const slideDownAbsolute = (arr, stagger, delay) => {
	gsap.to(arr, {
		bottom: '100%',
		stagger: stagger,
		delay: delay,
	})
}
export const slideDown = (arr, stagger, delay) => {
	gsap.to(arr, {
		y: 0,
		x: 0,
		z: 0,
		stagger: stagger,
		delay: delay,
	})
}
